import { Button } from '@mui/material'
import React from 'react'

const ButtonComponent = ({children,size,bgColor,borderColor,textColor,borderSquare,outlined,disabled,...rest}) => {
  return (
    <Button disabled={disabled} className='custom_btn' {...rest} disableElevation size={size? size : 'small'} sx={{borderRadius:borderSquare ? '3px' :'50px',background:bgColor&& bgColor,borderColor:borderColor && borderColor,color:textColor && textColor}} >
      {children}
    </Button>
  )
}

export default ButtonComponent;
